export default {
  items: {
    prices: 'Price List',
    disclosure: 'Disclosure',
    agreement: 'Service Charter',
    privacy: 'Privacy Policy',
  },
};
